import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
export function Problem() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const pains = [{
    question: '¿Llegás a casa agotada, sin fuerzas ni siquiera para relajarte?',
    text: 'Después de todo el día lidiando con el trabajo, el tráfico, las responsabilidades... llegás a tu casa y lo único que querés es DESCONECTAR. Pero no podés. Tu mente sigue a mil, tu cuerpo está tenso, y la sensación de peso no se va.'
  }, {
    question: '¿Sufrís de ansiedad, estrés o noches de insomnio?',
    text: 'Te acostás cansada pero tu cabeza no para. Das vueltas en la cama. Te despertás a las 3am con el pecho apretado. Y al día siguiente arrancás igual de agotada que cuando te fuiste a dormir.'
  }, {
    question: '¿Tenés pensamientos pesados y sentís que los ambientes están tensos?',
    text: 'Hay días que sentís una energía rara en tu casa. Como si todo estuviera cargado. Discusiones sin sentido. Mal humor constante. Y vos absorbés todo eso como una esponja.'
  }, {
    question: '¿Te gustaría atraer más prosperidad, amor y protección espiritual?',
    text: 'Sabés que merecés más. Más paz, más abundancia, más amor propio. Pero sentís que algo te bloquea. Como si estuvieras atrapada en la misma energía una y otra vez.'
  }];
  return <section ref={ref} className="py-20 sm:py-32 bg-[#F5F0E8] relative overflow-hidden" data-id="element-402">
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-[#B4A7D6]/10 rounded-full blur-[100px] -translate-y-1/2 translate-x-1/3" data-id="element-403"></div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-404">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-405">
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-[#2F4538] mb-6" data-id="element-406">
            ¿Te sentís así?
          </h2>
        </motion.div>

        <div className="space-y-6 mb-16" data-id="element-407">
          {pains.map((pain, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white p-6 sm:p-8 rounded-2xl shadow-sm border border-[#D4AF37]/20 flex gap-4 sm:gap-6" data-id="element-408">
              <div className="text-3xl sm:text-4xl shrink-0" data-id="element-409">😔</div>
              <div data-id="element-410">
                <h3 className="text-xl sm:text-2xl font-bold text-[#2F4538] mb-3 leading-snug" data-id="element-411">
                  {pain.question}
                </h3>
                <p className="text-[#1a1a1a]/80 text-lg leading-relaxed" data-id="element-412">
                  {pain.text}
                </p>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6,
        delay: 0.6
      }} className="bg-[#2F4538] text-[#F5F0E8] p-8 sm:p-10 rounded-3xl text-center shadow-xl border border-[#D4AF37]/20" data-id="element-413">
          <p className="text-xl sm:text-2xl font-medium mb-4" data-id="element-414">
            Si respondiste{' '}
            <span className="text-[#B4A7D6] font-bold" data-id="element-415">"SÍ"</span> a alguna de
            estas preguntas, seguí leyendo...
          </p>
          <p className="text-lg text-[#F5F0E8]/80" data-id="element-416">
            Porque lo que estás por descubrir cambió la vida de cientos de
            mujeres que, como vos, estaban cansadas de arrastrar el peso del día
            sin una salida real.
          </p>
        </motion.div>
      </div>
    </section>;
}